import React, {useEffect} from 'react';

import Home from './Home';
import Services from './Services';
import Features from './Features';
import Solutions from './Solutions';
import Faqs from './Faq';
import WorkProcess from './WorkProcess';
import Contact from './Contact';
import Prices from './Pricing';
import Clients from './Clients';

import {useTranslation} from 'react-i18next';
import {appConfig} from "../../config";

const Index = () => {
    const {t} = useTranslation();

    window.onscroll = function () {
        scrollFunction();
    };

    const scrollFunction = () => {
        const element = document.getElementById("back-to-top");
        if (element) {
            if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
                element.style.display = "block";
            } else {
                element.style.display = "none";
            }
        }
    };

    useEffect(() => {
        document.title = `${t('official')} - ${appConfig.appName}`;
    }, [])

    return (
        <div className="layout-wrapper landing">
            <Home/>
            <Features/>
            <Prices/>
            <Services/>
            <Solutions/>
            <Faqs/>
            <WorkProcess/>
            <Clients/>
            <Contact/>
        </div>
    );
};

export default Index;